<template>
  <div>
    <b-modal 
      id="bv-modal" 
      size="lg" 
      scrollable centered hide-footer 
      :title=country.Country>
      <div class="d-block ">
        <p> ITU Association: Member State </p>
      <h4>Regulatory Info</h4>
       <p v-if="country.Committee">  Regional Comittee: {{ country.Committee }} </p> 
       <p v-if="country.TelecomRegulator"> Telecom Regulator: {{ country.TelecomName }} </p> 
      <h5>Enabling Policies</h5>
       <ul v-if="country.Policies">
        <li v-for="policy in country.PoliciesName.split(',')" :key="policy">  {{ policy }} </li>
      </ul>
      <p v-else> Not found </p>
      <h5>Networks in the country</h5>
      <ul v-if="country.UseCases">
        <li v-for="usecase in country.UseCasesNames.split(',')" :key="usecase">  {{ usecase }} </li>
      </ul>
      <p v-else> Not found </p>  
      </div>
      <b-button class="mt-3" block @click="$bvModal.hide('bv-modal')"
        >Go Back</b-button
      >
    </b-modal>

  </div>
</template>

<script>
export default {
  props:{
    country: Object
  }
};
</script>
